import styled, { css } from 'styled-components';
import {
    Flex,
    spaceMixin,
    StyledButton,
    mediaMixin,
} from '@zillow/constellation';

export const StyledContainerMobile = styled.div`
    margin-top: auto;
    padding-top: ${spaceMixin('sm')};
    ${mediaMixin('lg', css`
        display: none;
    `)};
    ${StyledButton} {
        width: 100%;
    }
`;

export const StyledContainerDesktop = styled.div`
    margin-top: auto;
    padding-top: ${spaceMixin('md')};
    display: none;
    ${mediaMixin('lg', css`
        display: block;
    `)};
`;

export const StyledFlex = styled(Flex)`
    ${/* sc-selector */StyledButton}:nth-child(2) {
        margin-top: 8px;
    }

    ${mediaMixin('md', css`
        ${StyledButton}:nth-child(2) {
            margin-left: 8px;
            margin-top: 0px;
    }
    `)};
`;
